import queryString from 'query-string';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { NavigationBackButton } from '@/components/navigation-back-button';
import { routes } from '@/config';
import { useLoginStates } from '@/hooks';

export const SearchBackButton: React.VFC = () => {
  const { isLoggedOut } = useLoginStates();
  const { search } = useLocation();
  const { origin, sc_o_PropActionOrigin: propActionOrigin } = queryString.parse(search);

  const hasSearchAlertsParam = origin === 'search_alerts';
  const [isComingFromSearchAlerts] = useState(hasSearchAlertsParam);
  const isComingFromSatisfactionCheck = propActionOrigin === 'move_on_job_happiness_test_results_dashboard_jsl_module';

  let backButtonCopy = 'JOBS_POSTING_NAVIGATION_HOME';
  let backButtonTo: string = isLoggedOut ? '/' : routes.visionTypeFind;

  if (isComingFromSearchAlerts) {
    backButtonCopy = 'JOBS_SEARCH_ALERTS_PAGE_TITLE';
    backButtonTo = routes.visionTypeAlerts;
  } else if (isComingFromSatisfactionCheck) {
    backButtonCopy = 'BUTTON_BACK';
    backButtonTo = routes.jobHappiness;
  }

  return <NavigationBackButton title={<FormattedMessage id={backButtonCopy} />} to={backButtonTo} />;
};
